import { SeasonMewHero } from '../components/season-mew/hero/SeasonMewHero'
import { PointsInfoContainer } from '../components/season-mew/info/PointsInfoContainer'
import { Leaderboard } from '../components/season-mew/leaderboard/Leaderboard'

const USE_PLACEHOLDER = false

export function SeasonMewPointsView() {
  return (
    <div className="flex flex-col gap-4">
      <SeasonMewHero usePlaceholder={USE_PLACEHOLDER} />
      {!USE_PLACEHOLDER && (
        <>
          <PointsInfoContainer />
          <Leaderboard />
        </>
      )}
    </div>
  )
}
